import BannerLimit from '@/components/BannerLimit';
import InformationBanner from '@/components/InformationBanner';
import RegularText from '@/components/RegularText';
import Layout from '@/components/layout';
import { Plan, Rules, Touchpoint } from '@/constants/enum';
import { sendCrispMessage } from '@/helpers';
import { useCustomUserIdClarity } from '@/hooks/useCustomUserIdClarity';
import Analytic from '@/pages/Home/components/Analytic';
import Checklist from '@/pages/Home/components/Checklist';
import HelpCenter from '@/pages/Home/components/HelpCenter';
import bannerSlice, { bannerSelector } from '@/redux/slice/banner.slice';
import sessionSlice, { isShowBannerSelector } from '@/redux/slice/session.slice';
import { dataSettingsSelector, locationInfoSelector } from '@/redux/slice/settings.slice';
import { Button } from '@shopify/polaris';
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HomeStyled } from './styled';
import HolidayBanner from '@/components/HolidayBanner';

export const deliveryMethod = {
  [Rules.Methods]: 'Delivery methods',
  [Rules.PostCode]: 'Zipcode delivery',
  [Rules.Country]: 'Country shipping',
};

const HomePage = () => {
  useCustomUserIdClarity('Home');
  const isVisibleBannerLimit = useSelector(isShowBannerSelector);
  const { isVisibleBannerShiprocket, isVisibleBannerShiprocketPro } = useSelector(bannerSelector);
  const locationInfo = useSelector(locationInfoSelector);
  const dataSettings = useSelector(dataSettingsSelector);
  // const { isActivePlusPlan } = useUserPlan();

  const dispatch = useDispatch();
  // const recommendedAppsRef = useRef<HTMLDivElement>(null);
  // const isVisitedRecommendedApps = useOnScreen(recommendedAppsRef);

  // const trackGA4Event = useTrackGA4Event();

  // useEffect(() => {
  //   if (isVisitedRecommendedApps) {
  //     trackGA4Event(Ga4Event.SynctrackImpression);
  //     trackGA4Event(Ga4Event.ReturnsImpression);
  //   }
  // }, [isVisibleRecommendApps, isVisitedRecommendedApps, trackGA4Event]);

  // const handleClaimBanner = () => {
  //   sendCrispMessage(`I want to claim FREE 15-day trial of the ${isActivePlusPlan ? 'PLUS' : 'PRO'} plan.`);
  // };

  return (
    <Layout title="Home" fullWidth={false}>
      {/* <PopupCampaign handleClaim={handleClaimBanner} /> */}
      <HomeStyled>
        {/* <LifetimeBanner marginBottom="0" /> */}
        <HolidayBanner />
        <Analytic />
        {locationInfo && locationInfo.data?.country_code === 'IN' ? (
          <div>
            {dataSettings.plan === Plan.PRO || dataSettings.plan === Plan.SHOPIFY_PLUS ? (
              <InformationBanner
                isVisible={isVisibleBannerShiprocketPro}
                title="Integrate with Shiprocket to show estimated delivery date."
                onDismiss={() => {
                  dispatch(bannerSlice.actions.handleVisibleBanner({ key: 'isVisibleBannerShiprocketPro', value: false }));
                }}
              >
                <RegularText>
                  Are you using Shiprocket? Let’s increase conversion in any area of India by showing ETA banner based on postal
                  codes, minimum and maximum estimated delivery dates.
                </RegularText>
                <div className="mt-8">
                  <Button
                    onClick={() => {
                      sendCrispMessage('Hi, I want to integrate with Shiprocket to show estimated delivery date.');
                    }}
                  >
                    Contact us
                  </Button>
                </div>
              </InformationBanner>
            ) : null}
            {dataSettings.plan === Plan.FREE || dataSettings.plan === Plan.STANDARD ? (
              <InformationBanner
                isVisible={isVisibleBannerShiprocket}
                title="Upgrade to Pro Plan to integrate with Shiprocket for delivery estimates."
                onDismiss={() => {
                  dispatch(bannerSlice.actions.handleVisibleBanner({ key: 'isVisibleBannerShiprocket', value: false }));
                }}
              >
                <RegularText>
                  Are you using Shiprocket? Let’s increase conversion in any area of India by showing ETA banner based on postal
                  codes, minimum and maximum estimated delivery dates.
                </RegularText>
              </InformationBanner>
            ) : null}
          </div>
        ) : null}
        <div>
          <BannerLimit
            touchpoint={Touchpoint.HomeTopBanner}
            isVisible={isVisibleBannerLimit.isVisibleBannerLimitInHome}
            onDismiss={() => {
              dispatch(sessionSlice.actions.handleBanner({ key: 'isVisibleBannerLimitInHome', value: false }));
            }}
          />
        </div>
        <div>
          <Checklist />
        </div>
        <div>
          <HelpCenter />
        </div>
        {/* {isVisiblePromotions ? (
          <div>
            <PromotionsCard />
          </div>
        ) : null}
        {isVisibleRecommendApps ? (
          <div>
            <Card>
              <div className="apps-title">
                <BoldText>Other high-quality apps from Synctrack</BoldText>
                <div className="recommend-apps-controller">
                  <div onClick={() => window.open('https://synctrack.io/partners/', '_blank')}>
                    <Tooltip content="View all">
                      <Icon source={MenuHorizontalIcon} />
                    </Tooltip>
                  </div>

                  <div
                    className="ml-8"
                    onClick={() => {
                      dispatch(bannerSlice.actions.handleVisibleBanner({ key: 'isVisibleRecommendApps', value: false }));
                    }}
                  >
                    <Tooltip content="Dismiss">
                      <Icon source={XIcon} tone="base" />
                    </Tooltip>
                  </div>
                </div>
              </div>

              <div className="mt-16 apps-wrapper" ref={recommendedAppsRef}>
                <RecommendedApps />
              </div>
            </Card>
          </div>
        ) : null} */}
      </HomeStyled>
    </Layout>
  );
};

export default memo(HomePage);
